import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";

type Props = {
  content: ReactNode;
};

export function AdditionalInformationCard({ content }: Props) {
  const intl = useIntl();

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        id: "trips.additionalInformation.title",
        defaultMessage: "Additional Information",
      })}
      expandedByDefault={false}
    >
      <div className="text-sm text-text-primary">{content}</div>
    </CollapsibleCard>
  );
}
